module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-export-text"
    }
  }, [_vm._v("\n\texport text\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a580d2ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoExportText.vue
// module id = 3948
// module chunks = 1